module.exports = __webpack_public_path__ + "static/media/Settings.4b9c4645.svg";